var React = require('react');

function Fleet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Command Burst"),React.createElement("g",{"id":"g1622","key":2},[React.createElement("path",{"id":"path3685-7-4","className":"cls-1","d":"M19,112.56,66.5,88.28,114,112.56","key":0}),React.createElement("path",{"id":"path3685-7-4-9","className":"cls-1","d":"M19,76.14,66.5,51.86,114,76.14","key":1}),React.createElement("path",{"id":"path3685-7-4-0","className":"cls-1","d":"M19,39.72,66.5,15.44,114,39.72","key":2})])]);
}

Fleet.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Fleet;

Fleet.default = Fleet;
